<template>
  <TableGradient
      icon-name="medkit"
      :title="$t('core_sectors.index.listagem_setores')"
      :text-empty="$t('core_sectors.index.setor_nao_encontrado')"
      route-new="coresectors.create"
      :text-new="$t('core_sectors.index.criar_setor')"
      :fields="fields"
      :items="coresectors"
      :paginator="paginator"
      :loading="isLoading"
      @list="evt => $store.dispatch('coresectors/listAllPaginated', evt)"
      table-data
      disable-filters
  >
    <template v-slot:cell(id)="{ index, item: { id }}">
      <router-link :id="`link-edit-${index}`" :to="{ name: 'coresectors.edit', params: { id }}" class="font-weight-bold">
        {{ $t('core_sectors.index.editar') }}
      </router-link>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      coresectors: 'coresectors/all',
      paginator: 'coresectors/pagination',
      store_isLoading: 'coresectors/isLoading'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('core_sectors.index.nome'), sortable: true},
        {key: 'mnemonic', label: this.$t('core_sectors.index.apelido'), sortable: true},
        {key: 'veus_sector_id', label: 'VS ID', sortable: true},
        {key: 'id', label: this.$t('core_sectors.index.editar')}
      ]
    }
  },
  methods: {
    ...mapActions([
      'coresectors/listAllPaginated'
    ])
  },
  mounted() {
    this['coresectors/listAllPaginated'](this.paginator)
    this.mounted = true
  }
}
</script>